import React from "react";

const linkClass = "text-primary underline disabled:opacity-50";

const traysLabel = (count) => `${count} ${count === 1 ? "tray" : "trays"}`;

/**
 * Shown while trays are picked for bulk label printing: how many are picked,
 * a way to pick every tray matching the current search (not just the loaded
 * pages), and a way to clear the selection.
 */
const TraySelectionBar = ({
  count,
  totalCount,
  isSearching,
  allMatchingSelected,
  selectingAll,
  onSelectAll,
  onClear,
}) => (
  <div className="flex items-center gap-3 flex-wrap rounded-md border border-D0D5DD px-3 py-2 text-xs text-[var(--list-table-row-fg-color)]">
    <span className="fw_600">{traysLabel(count)} selected for label printing</span>
    {!allMatchingSelected && totalCount > 0 && (
      <button type="button" className={linkClass} disabled={selectingAll} onClick={onSelectAll}>
        {selectingAll
          ? "Selecting…"
          : `Select all ${traysLabel(totalCount)}${isSearching ? " matching this search" : ""}`}
      </button>
    )}
    <button type="button" className={linkClass} disabled={selectingAll} onClick={onClear}>
      Clear selection
    </button>
  </div>
);

export default TraySelectionBar;
